// admin-api/lib/plan-review/submitterTags.js
//
// THE SUBMITTER'S TAG VOCABULARY. One declaration, in a file the BROWSER CAN
// IMPORT.
//
// ── WHY THIS IS NOT IN planReviewSubmission.js ──────────────────────────────
//
// It was, and it could not stay there. That module opens with
// `import { createHash } from "node:crypto"`, so importing it from ui/ either
// fails the vite build or pulls a Node polyfill into the browser bundle. The
// portal's tagging control needs these three strings and must not re-type them:
// a vocabulary typed into the UI is how `awaiting_submission` and `returned`
// shipped as plan-review statuses that do not exist, and how
// portalApi.upload.test.js came to assert a tag called `well_pad`.
//
// So the constant moves to a leaf with NO imports at all, and
// planReviewSubmission.js re-exports it. Every existing server call site is
// unchanged; there is still exactly one declaration, and now there is one the
// browser can reach.
//
// This is roleLabels.js's shape, for roleLabels.js's reason — see
// ui/Dockerfile, which copies both into the image so the relative import that
// resolves on a developer's disk also resolves inside the artifact.
//
// ── DO NOT ADD A FOURTH VALUE FOR "UNTAGGED" ────────────────────────────────
//
// Untagged is the ABSENCE of an assertion, not a kind of one. It has no
// encoding anywhere: the client holds tags in a Map keyed by ordinal and an
// untagged feature is simply not in it (ui/src/portal/portalTags.js). A
// sentinel here would be a value that serialises, and
// aiprime.plan_review_features_tag_chk would refuse it at the very end of a
// flow the submitter has already finished.

/**
 * The submitter's vocabulary. Matches `plan_review_features_tag_chk`.
 *
 * Frozen for MARKUP_KEYS' reason: an allow-list a caller can mutate is not one.
 * An ARRAY rather than a Set — `Object.freeze(new Set([...]))` is not immutable,
 * because freeze does not reach a Set's internal slot (REM-379).
 */
export const SUBMITTER_TAGS = Object.freeze(["pad", "road", "other"]);

/** @returns {boolean} true only for a member of SUBMITTER_TAGS. */
export function isSubmitterTag(value) {
  return typeof value === "string" && SUBMITTER_TAGS.includes(value);
}
